import Frontpage from '../components/Frontpage.vue';
import Protocol from '../components/Protocol.vue';
import LandlordAddress from '../components/steps/LandlordAddress.vue';
import TenantAddress from '../components/steps/TenantAddress.vue';
import MoveDate from '../components/steps/MoveDate.vue';
import Takeover from '../components/steps/Takeover.vue';
import MoveOutDate from '../components/steps/MoveOutDate.vue';
import Inventory from '../components/steps/Inventory.vue';
import Furnishing from '../components/steps/Furnishing.vue';
import Condition from '../components/steps/Condition.vue';
import Conditionsummary from '../components/steps/ConditionSummary.vue';
import Keys from '../components/steps/Keys.vue';
import Fire from '../components/steps/Fire.vue';
import Inspection from '../components/steps/Inspection.vue';
import Water from '../components/steps/Water.vue';
import Meters from '../components/steps/Meters.vue';
import Gasmeter from '../components/steps/Gasmeter.vue';
import Hotwater from '../components/steps/Hotwater.vue';
import DistrictHeating from '../components/steps/DistrictHeating.vue';
import PowerMeter from '../components/steps/PowerMeter.vue';
import PowerOrder from '../components/steps/PowerOrder.vue';
import PowerSelect from '../components/steps/PowerSelect.vue';
import Signing from '../components/steps/Signing.vue';
import Rooms from '../components/steps/Rooms.vue';
import General from '../components/steps/General.vue';
import GeneralAdvanced from '../components/steps/GeneralAdvanced.vue';
import Cleaning from '../components/steps/Cleaning.vue';

import Participants from '../components/steps/Participants.vue';
import Settlement from '../components/steps/Settlement.vue';
import Deposit from '../components/steps/Deposit.vue';
import Welcome from '../components/Welcome.vue';

import Basics from '../components/steps/inspection/Basics.vue';
import Property from '../components/steps/inspection/Property.vue';
import Cost from '../components/steps/inspection/Cost.vue';
import InspectionRooms from '../components/steps/inspection/Rooms.vue';
import Extended from '../components/steps/inspection/Extended.vue';
import Etakst from '../components/steps/inspection/Etakst.vue';

import Powersub from '../components/steps/str/PowerSub.vue';
import Powerinfo from '../components/steps/str/PowerInfo.vue';

import Confirmation from '../components/steps/otps/Confirmation.vue';
import SaleParticipants from '../components/steps/otps/Participants.vue';
import SaleCleaning from '../components/steps/otps/Cleaning.vue';
import SaleKeys from '../components/steps/otps/Keys.vue';
import SaleFire from '../components/steps/otps/Fire.vue';
import SalePowerMeter from '../components/steps/otps/PowerMeter.vue';
import SalePowerOrder from '../components/steps/otps/PowerOrder.vue';
import SaleSettlement from '../components/steps/otps/Settlement.vue';
import SaleWater from '../components/steps/otps/Water.vue';
import SaleSigning from '../components/steps/otps/Signing.vue';

import DynamicStep from '../components/DynamicStep.vue'

import Security from '../components/steps/Security.vue';
import Insurance from '../components/steps/Insurance.vue';

import Vitec from '../components/Vitec.vue'

export default [
  {
    path: '/:protocolHash',
    components: {
      main: Protocol
    },
    children: [
      {
        path: '',
        name: 'welcome',
        components: {
          protocol: Welcome
        }
      },
      {
        path: 'forside',
        name: 'frontpage',
        components: {
          protocol: Welcome
        }
      },
      {
        name: 'participants',
        path: 'tilstede',
        components: {
          protocol: Participants
        }
      },
      {
        name: 'settlement',
        path: 'oppgjor',
        components: {
          protocol: Settlement
        }
      },
      {
        name: 'deposit',
        path: 'depositum',
        components: {
          protocol: Deposit
        }
      },
      {
        name: 'landlord',
        path: 'utleier',
        components: {
          protocol: LandlordAddress
        }
      },
      {
        name: 'tenant',
        path: 'leietager',
        components: {
          protocol: TenantAddress
        }
      },
      {
        name: 'movedate',
        path: 'flyttedato',
        components: {
          protocol: MoveDate
        }
      },
      {
        name: 'takeover',
        path: 'overtakelse',
        components: {
          protocol: Takeover
        }
      },
      {
        name: 'moveoutdate',
        path: 'utflyttedato',
        components: {
          protocol: MoveOutDate
        }
      },
      {
        name: 'inventory',
        path: 'inventar',
        components: {
          protocol: Inventory
        }
      },
      {
        name: 'condition',
        path: 'tilstand',
        components: {
          protocol: Condition
        }
      },
      {
        name: 'conditionsummary',
        path: 'tilstandoversikt',
        components: {
          protocol: Conditionsummary
        }
      },
      {
        name: 'keys',
        path: 'nokler',
        components: {
          protocol: Keys
        }
      },
      {
        name: 'fire',
        path: 'brannsikkerhet',
        components: {
          protocol: Fire
        }
      },
      {
        name: 'inspection',
        path: 'befaring',
        components: {
          protocol: Inspection
        }
      },
      {
        name: 'districtheating',
        path: 'fjernvarme',
        components: {
          protocol: DistrictHeating
        }
      },
      {
        name: 'water',
        path: 'vannmaler',
        components: {
          protocol: Water
        }
      },
      {
        name: 'meters',
        path: 'malere',
        components: {
          protocol: Meters
        }
      },
      {
        name: 'gasmeter',
        path: 'gassmaler',
        components: {
          protocol: Gasmeter
        }
      },
      {
        name: 'hotwater',
        path: 'varmtvannsmaler',
        components: {
          protocol: Hotwater
        }
      },
      {
        name: 'power',
        path: 'strommaler',
        components: {
          protocol: PowerMeter
        }
      },
      {
        name: 'powerorder',
        path: 'strombestilling',
        components: {
          protocol: PowerOrder
        }
      },
      {
        name: 'powerselect',
        path: 'stromvalg',
        components: {
          protocol: PowerSelect
        }
      },
      {
        name: 'rooms',
        path: 'rom',
        components: {
          protocol: Rooms
        }
      },
      {
        name: 'signing',
        path: 'underskrift',
        components: {
          protocol: Signing
        }
      },
      {
        name: 'inspection-basics',
        path: 'boligen',
        components: {
          protocol: Basics
        }
      },
      {
        name: 'inspection-property',
        path: 'eiendom',
        components: {
          protocol: Property
        }
      },
      {
        name: 'inspection-cost',
        path: 'kostnader',
        components: {
          protocol: Cost
        }
      },
      {
        name: 'inspection-rooms',
        path: 'rom-i-boligen',
        components: {
          protocol: InspectionRooms
        }
      },
      {
        name: 'inspection-extended',
        path: 'utvidet-info',
        components: {
          protocol: Extended
        }
      },
      {
        name: 'inspection-etakst',
        path: 'etakst',
        components: {
          protocol: Etakst
        }
      },
      {
        name: 'powersub',
        path: 'stromabo',
        components: {
          protocol: Powersub
        }
      },
      {
        name: 'powerinfo',
        path: 'strominfo',
        components: {
          protocol: Powerinfo
        }
      },
      {
        name: 'confirmation',
        path: 'bekreftelse',
        components: {
          protocol: Confirmation
        }
      },
      {
        name: 'sale-participants',
        path: 'tilstede-salg',
        components: {
          protocol: SaleParticipants
        }
      },
      {
        name: 'sale-cleaning',
        path: 'vask-salg',
        components: {
          protocol: SaleCleaning
        }
      },
      {
        name: 'sale-keys',
        path: 'nokler-salg',
        components: {
          protocol: SaleKeys
        }
      },
      {
        name: 'sale-fire',
        path: 'brann-salg',
        components: {
          protocol: SaleFire
        }
      },
      {
        name: 'sale-powermeter',
        path: 'strommaler-salg',
        components: {
          protocol: SalePowerMeter
        }
      },
      {
        name: 'sale-powerorder',
        path: 'strombestilling-salg',
        components: {
          protocol: SalePowerOrder
        }
      },
      {
        name: 'sale-settlement',
        path: 'tilbakehold-salg',
        components: {
          protocol: SaleSettlement
        }
      },
      {
        name: 'sale-water',
        path: 'vannmaler-salg',
        components: {
          protocol: SaleWater
        }
      },
      {
        name: 'sale-signing',
        path: 'signering-salg',
        components: {
          protocol: SaleSigning
        }
      },
      {
        name: 'general',
        path: 'kommentarer',
        components: {
          protocol: General
        }
      }, 
      {
        name: 'cleaning',
        path: 'vask',
        components: {
          protocol: Cleaning
        }
      },
      {
        name: 'furnishing',
        path: 'moblering',
        components: {
          protocol: Furnishing
        }
      },
      {
        name: 'security',
        path: 'sikkerhet',
        components: {
          protocol: Security
        }
      },
      {
        name: 'insurance',
        path: 'forsikring',
        components: {
          protocol: Insurance
        }
      },
      {
        name: 'generaladvanced',
        path: 'genereltliste',
        components: {
          protocol: GeneralAdvanced
        }
      },
      {
        name: 'dynamic',
        path: ':page',
        components: {
          protocol: DynamicStep
        }
      }         
    ]
  },
  {
    path: '/vitec/:provider/:protocolType/:estateId',
    components: {
      main: Vitec
    }
  }
];